import { useParams } from "react-router-dom";
import { RoleBriefView } from "../ws7/agent/RoleBriefView";
import "../ws7/ws7.css";

/** /agent/:role: one team role's brief (docs/agents/<role>.md) with its scopes, start page and work queue. */
export function RoleBriefPage() {
  const { role = "" } = useParams();
  return <RoleBriefView key={role} roleId={role} />;
}
